"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessFactoryFromJS = exports.ProcessFactory = void 0;
const immutable_1 = require("immutable");
exports.ProcessFactory = (0, immutable_1.Record)({
    processId: null,
    projectId: null,
    flowId: null,
    createDate: null,
    finishDate: null,
    deleteDate: null,
    packageVersion: null,
    latestPackageVersion: null,
    userName: null,
    projectName: null,
    flowName: null,
    errorInfo: null,
    projectSecretKey: null,
    projectCaption: (0, immutable_1.Map)(),
    flowCaption: (0, immutable_1.Map)(),
    flowStatus: (0, immutable_1.Map)()
});
const ProcessFactoryFromJS = function (data) {
    return (0, exports.ProcessFactory)(Object.assign(Object.assign({}, data), { projectCaption: (0, immutable_1.Map)(data.projectCaption), flowCaption: (0, immutable_1.Map)(data.flowCaption), flowStatus: (0, immutable_1.Map)(data.flowStatus) }));
};
exports.ProcessFactoryFromJS = ProcessFactoryFromJS;
//# sourceMappingURL=IProcess.js.map